'use client';

import dynamic from 'next/dynamic';

//* Components
import Page from '@/components/global/Page';
import HeroSection from '@/components/sections/HeroSection';

const MouseHoverSection = dynamic(() => import('@/components/sections/MouseHoverSection'), { ssr: false })
const GoldenRationSection = dynamic(() => import('./components/GoldenRationSection'), { ssr: false })
const DigitalAestheticAnalysisSection = dynamic(() => import('./components/DigitalAestheticAnalysisSection'), { ssr: false })
const ServiceSection = dynamic(() => import('./components/ServiceSection'), { ssr: false })

//* Style
import PhilosophyPageStyle from '@/styles/pages/PhilosophyPageStyle';

export default function PhilosophyTemplate({ pageData }) {
    return (
        <Page className={'philosophy'}>
            <PhilosophyPageStyle>
                <HeroSection {...pageData.data.hero} />

                <MouseHoverSection {...pageData.data.info} />

                <GoldenRationSection {...pageData.data.golden_ration} />

                <DigitalAestheticAnalysisSection {...pageData.data.digital_aesthetic_analysis} />

                <ServiceSection {...pageData.data.service} />
            </PhilosophyPageStyle>
        </Page>
    );
}
